export enum LatestNewsCategories{
    News = 1,
    Learning = 2,
    Updates = 3,
    Forum = 4,
}